// extracted by mini-css-extract-plugin
export var centerText = "_50-8";
export var container = "_50-0";
export var doughnutContainer = "_50-7";
export var legend = "_50-a";
export var legendItemColorDisplay = "_50-b";
export var legendItemLabel = "_50-d";
export var legendItemValue = "_50-c";
export var lg = "_50-5";
export var maxWidth = "_50-9";
export var md = "_50-4";
export var responsive = "_50-6";
export var sm = "_50-3";
export var xs = "_50-2";
export var xxs = "_50-1";